export default __webpack_public_path__ + "static/media/addProduct.3eb325cb.jpg";